/**
 * @generated SignedSource<<3bb8df2175bad1bdaa21ac2eb7f10fec>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type AppointmentStatus = "CANCELLED" | "CLOSED" | "IN_PROGRESS" | "OPEN";
import { FragmentRefs } from "relay-runtime";
export type requestTakeOverDialog_patientFileLockFragment$data = {
  readonly appointment: {
    readonly chatDetails: {
      readonly chatThreadId: string;
    } | null;
    readonly id: string;
    readonly isCompleted: boolean;
    readonly startingSoonNotificationSent: boolean;
    readonly status: AppointmentStatus;
    readonly takenAt: string | null;
  } | null;
  readonly id: string;
  readonly lockRequestedAt: string | null;
  readonly lockRequestedBy: string | null;
  readonly lockedAt: string | null;
  readonly lockedBy: string | null;
  readonly patientId: string;
  readonly " $fragmentType": "requestTakeOverDialog_patientFileLockFragment";
};
export type requestTakeOverDialog_patientFileLockFragment$key = {
  readonly " $data"?: requestTakeOverDialog_patientFileLockFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"requestTakeOverDialog_patientFileLockFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "requestTakeOverDialog_patientFileLockFragment",
  "selections": [
    (v0/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "patientId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lockedBy",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lockedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lockRequestedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lockRequestedBy",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Appointment",
      "kind": "LinkedField",
      "name": "appointment",
      "plural": false,
      "selections": [
        (v0/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "takenAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "startingSoonNotificationSent",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "status",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isCompleted",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "AppointmentChatDetails",
          "kind": "LinkedField",
          "name": "chatDetails",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "chatThreadId",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "PatientFileLock",
  "abstractKey": null
};
})();

(node as any).hash = "da9e039a8bce5ef749be63b7eaef9c93";

export default node;
